import InfoOutlined from '@mui/icons-material/InfoOutlined';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip from '@mui/material/Tooltip';
import type { ReactNode } from 'react';

interface InfoTipProps {
  text: string;
  placement?: TooltipProps['placement'];
  onOpen?: () => void;
}

/** The dark tooltip look, for any element that needs the same tip without the info icon. */
export const INFO_TIP_SLOT_PROPS: TooltipProps['slotProps'] = {
  tooltip: {
    sx: {
      bgcolor: 'text.primary',
      color: 'common.white',
      fontSize: 11,
      fontWeight: 500,
      maxWidth: 220,
      p: 2,
      borderRadius: 1,
      border: 'none',
    },
  },
  arrow: { sx: { color: 'text.primary' } },
};

export function InfoTip({ text, placement = 'top', onOpen }: InfoTipProps): ReactNode {
  return (
    <Tooltip
      title={text}
      placement={placement}
      {...(onOpen === undefined ? {} : { onOpen })}
      arrow
      slotProps={INFO_TIP_SLOT_PROPS}
    >
      <InfoOutlined sx={{ fontSize: 13, color: 'text.disabled', cursor: 'help' }} />
    </Tooltip>
  );
}
